export default {
  title: 'Crea tu Aplicación',
  description:
    'Construye tu aplicación sobre Remix SaaS, explora la documentación y comienza tu viaje.',
}
